import { useMutation } from '@tanstack/react-query';
import { postDataProcessor } from '@leagueplatform/masonry-api';
import {
  DataProcessorResult,
  MESSAGE_FIELD_ID,
  SUCCESS_FIELD_ID,
} from 'types/data-processor.types';
import { getFieldValue } from 'utils/data-processor.utils';

type SetMarketingPreferencesRequest = {
  email: boolean;
};

const SET_MARKETING_PREFERENCES_DATA_PROCESSOR_ID = 'setMarketingPreferences';
const EMAIL_FIELD_ID = 'email';

export const useSetMarketingPreferences = () =>
  useMutation<DataProcessorResult, Error, SetMarketingPreferencesRequest>({
    mutationFn: async ({ email }) => {
      const response = await postDataProcessor({
        dataProcessorId: SET_MARKETING_PREFERENCES_DATA_PROCESSOR_ID,
        fields: [{ id: EMAIL_FIELD_ID, value: email }],
      });

      if (response.status !== 'success') {
        throw new Error(
          response.message ||
            response.errors?.[0]?.message ||
            'Failed to set marketing preferences',
        );
      }

      const success = getFieldValue(response.fields, SUCCESS_FIELD_ID) === true;

      if (!success) {
        const rawMessage = getFieldValue(response.fields, MESSAGE_FIELD_ID);
        const message =
          typeof rawMessage === 'string' && rawMessage ? rawMessage : undefined;
        return { success: false, message };
      }

      return { success: true };
    },
  });
